import React, { FC, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../shared/components/Icon/Icon";
import { Select } from "../../shared/components/Select/Select";
import { useMatchMedia } from "../../shared/hooks/useMatchMedia";
import classes from "./Header.module.scss";
import clsx from "clsx";

export const Header: FC = () => {
	const { isMobile }: any = useMatchMedia();
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const handleIsOpen = () => {
		setIsOpen(!isOpen);

		if (!isOpen) document.body.style.overflow = "hidden";
		else document.body.style.overflow = "auto";
	};

	const burgerClassName = useMemo(
		() => clsx(classes.burger, { [classes.open]: isOpen === true }),
		[isOpen]
	);

	const rightClassName = useMemo(
		() =>
			clsx(classes.right, {
				[classes.isBurger]: isOpen,
			}),
		[isOpen]
	);

	const { t } = useTranslation();
	return (
		<header>
			{!isMobile ? (
				<div className={classes.wrapper}>
					<div className={classes.left}>
						<Icon className={classes.icon} name="logo" />
						<ul className={classes.links}>
							<li className={classes.text}>{t("translation.header.play")}</li>
							<li className={classes.text}>{t("translation.header.paper")}</li>
							<li className={classes.text}>{t("translation.header.links")}</li>
							<li className={classes.text}>
								<Icon name="cart" />
								{t("translation.header.market")}
							</li>
						</ul>
					</div>

					<div className={classes.right}>
						<Icon name="language" />
						<Select />
						<div className={classes.icons}>
							<button className={classes.button}>
								<Icon className={classes.social} name="discord" />
							</button>

							<button className={classes.button}>
								<Icon className={classes.social} name="telegram" />
							</button>

							<button className={classes.button}>
								<Icon className={classes.social} name="twitter" />
							</button>

							<button className={classes.button}>
								<Icon className={classes.social} name="youtube" />
							</button>
						</div>
					</div>
				</div>
			) : (
				<div className={classes.mobile}>
					<Icon className={classes.icon} name="logo" />
					<div className={rightClassName}>
						<Select />

						<span onClick={handleIsOpen} className={burgerClassName} />

						{isOpen && (
							<div className={classes.isOpen}>
								<ul className={classes.mobileLinks}>
									<li className={classes.text} onClick={handleIsOpen}>
										{t("translation.header.play")}
									</li>
									<li className={classes.text} onClick={handleIsOpen}>
										{t("translation.header.paper")}
									</li>
									<li className={classes.text} onClick={handleIsOpen}>
										{t("translation.header.links")}
									</li>
									<li className={classes.text} onClick={handleIsOpen}>
										<Icon name="cart" size={30} />
										{t("translation.header.market")}
									</li>
								</ul>

								<div className={classes.icons}>
									<button className={classes.button}>
										<Icon className={classes.social} name="discord" />
									</button>

									<button className={classes.button}>
										<Icon className={classes.social} name="telegram" />
									</button>

									<button className={classes.button}>
										<Icon className={classes.social} name="twitter" />
									</button>

									<button className={classes.button}>
										<Icon className={classes.social} name="youtube" />
									</button>
								</div>
							</div>
						)}
					</div>
				</div>
			)}
		</header>
	);
};
